import React from 'react';

import { cn } from 'lib/helpers/utility';

import Icon from '../Icon/Icon';

const THEMES = {
  dark: {
    frame: 'bg-gradient-to-b from-neutral-800 to-neutral-700 p-[1px]',
    cap: 'bg-neutral-800 text-white',
    icon: 'white'
  },
  light: {
    frame: 'border border-solid border-neutral-400',
    cap: 'bg-neutral-75 text-neutral-800',
    icon: 'neutral-800'
  },
  translucent: {
    frame: 'border border-solid border-white/30',
    cap: 'bg-white/10 text-white',
    icon: 'white'
  }
};

/**
 * @param {import('./lib/propTypes').KeyProps}
 */

const Key = ({ text, theme = 'dark', icon }) => {
  const { frame, cap, icon: iconColor } = THEMES[theme] || THEMES.dark;

  return (
    <div className={cn('flex h-fit w-fit items-center justify-center rounded-[3px]', frame)}>
      <div
        className={cn(
          'flex h-fit min-h-[18px] w-fit min-w-[18px] items-center justify-center rounded-[3px] p-[3px]',
          cap
        )}>
        {!icon && (
          <span className="text-center font-apple text-xxs font-500 leading-none">{text}</span>
        )}
        {icon && <Icon icon={icon} color={iconColor} size={10} />}
      </div>
    </div>
  );
};

export default Key;
